import { Injectable } from '@angular/core';
import {ApiService} from "../api.service";

@Injectable({
  providedIn: 'root'
})
export class AuthApiService {

  private loginApi = "/api/login";
  private loginMethodApi = "/api/loginmethod";
  private resetPasswordApi = "/api/resetpassword";
  private verifyCaptchaTokenApi = "/api/verifyCaptchaToken";

  constructor(private api: ApiService) { }

  public getLoginMethod(emailAddress){
    return this.api.post(this.loginMethodApi, {EmailAddress: emailAddress});
  }

  public login(emailAddress, password,verifycaptcha,IsCaptchaAvailable){

    let loginPayload = {
      EmailAddress: emailAddress,
      Password:  password,
      Verifycaptcha:verifycaptcha,
      IsCaptchaAvailable:IsCaptchaAvailable
    }

    return this.api.post(this.loginApi, loginPayload);

  }

  public resetPassword(emailAddress){
    let loginPayload = {
      EmailAddress: emailAddress,
    }

    return this.api.post(this.resetPasswordApi, loginPayload);
  }
// verify the token
  public verifyCaptchaToken(token){
    const CaptchaToken=JSON.stringify({ token })
    return this.api.post(this.verifyCaptchaTokenApi,CaptchaToken);
  }

  // Get the chaptcha site key
  public getSiteKey(){
    return this.api.get(this.verifyCaptchaTokenApi);
  }

  // check the captcha availability
  public IsCaptchaAvailable():Promise<boolean>{
    return this.api.get(this.verifyCaptchaTokenApi+'/isCaptchaAvailable');
  }
}
